import React from 'react';

import styles from './evaluation.module.css';

import CTAButton from "../../../common/v2/CTA-Button/cta-button";
import {ABOUT_PAGE_CONTENT} from "../../about/aboutPageContent";

const Evaluation: React.FC = () => {


    return (
        <>
            <section className={styles.section_container}>
                <div className={styles.content_wrapper}>
                    <div className={styles.image_container}>
                        <img
                            src="/images/programs/evaluation.jpg"
                            alt="Espace chaleureux de la garderie"
                            className={styles.image}/>
                    </div>

                    <div className={styles.text_content}>
                        <h2 className={styles.section_title}>
                            {" Évaluation des objectifs d'apprentissage"}
                        </h2>
                    </div>
                    <p className={styles.intro_paragraph}>
                        Pour évaluer si un enfant a atteint ses paliers d’apprentissage,
                        tout en respectant son propre rythme de développement, j’observe attentivement les tâches qu’il est capable de réaliser seul
                        ou avec aide, dans différentes situations de jeu, d’activité ou de vie quotidienne.
                    </p>
                    <p className={styles.intro_paragraph}>
                        J’analyse également ses comportements et ses progrès à travers une observation continue, bienveillante et individualisée.
                        Ces observations me permettent ensuite de comparer les compétences acquises aux objectifs attendus pour son âge.
                    </p>

                </div>
            </section>
            <CTAButton text={"Obtenir Plus D'information"} href={"/contact"}/></>
    );
};

export default Evaluation;
